import {
  TRANSACTION_TYPE_FILTERS,
} from '../../../assets/constants/historyData';

export function hasExplicitHistoryFilters(filters = {}) {
  const selectedCardIds = Array.isArray(filters.cardIds)
    ? filters.cardIds
    : [];

  return Boolean(filters.dateRange)
    || selectedCardIds.length > 0
    || filters.type === TRANSACTION_TYPE_FILTERS.INCOME
    || filters.type === TRANSACTION_TYPE_FILTERS.EXPENSE;
}

export function getHistoryEmptyState(filters = {}, history = {}) {
  if (String(filters.query || '').trim().length > 0) {
    return {
      title: history.emptyTitle,
      text: history.tryDifferentSearch,
    };
  }

  if (hasExplicitHistoryFilters(filters)) {
    return {
      title: history.filteredEmptyTitle,
      text: history.filteredEmptyText,
    };
  }

  return {
    title: history.noOperationsTitle,
    text: history.noOperationsText,
  };
}
